import globals from '../../utils/globals';

const formatDateInLocalTimezone = (timestamp: number) => (
  new Intl.DateTimeFormat(globals('communityLanguage'), {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(timestamp)
)

export default formatDateInLocalTimezone

